/* eslint-disable no-console */
/* eslint-disable max-len */
import React from 'react';
import { get } from 'lodash';

const SchematiDiagramSVG = (props) => {
  const { cocurrent, ediDetails } = props;
  let dilution_output = {
    'current_stack': 0,
    'voltage': '',
    'max_all_recovery': '',
    'energy_cons': '',
    'feed_flow': '',
    'feed_pressure': 0,
    'prod_flow': 0,
    'prod_pressure': '',
    'conc_bleed_flow': '',
    'electrode_bleed_flow': '',
    'max_conc_inlet_press': 0,
    'max_conc_outlet_press': 0,
    'max_electrode_bleed_press': 0,
    'Flow Configuration': 'Counter-Current'
  };
  let System_units = {};
  if (localStorage.getItem('edi-output-dict')) {
    const outputdata = get(JSON.parse(localStorage.getItem('edi-output-dict')), `EDI.${ediDetails.id}`, {});
    // eslint-disable-next-line prefer-destructuring
    dilution_output = outputdata.output_user.dilution_output;
  }
  if (localStorage.getItem('unit_set_dict')) {
    System_units = JSON.parse(localStorage.getItem('unit_set_dict'));
  };
  return (
    <svg width="825" height="348" viewBox="0 0 825 348" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ margin: '0 auto' }}>
      <rect x="276" y="99" width="273" height="80" rx="7" stroke="#002D62" strokeWidth="2" />
      <text fill='#002d62' x='370' y='150' fontSize='25' fontWeight='bold'>Dilute</text>
      <rect x="276" y="183" width="273" height="80" rx="7" stroke="#002D62" strokeWidth="2" />
      <text fill='#002d62' x='340' y='230' fontSize='25' fontWeight='bold'>Concentrate</text>
      <rect x="276" y="267" width="273" height="80" rx="7" stroke="#002D62" strokeWidth="2" />
      <text fill='#002d62' x='355' y='310' fontSize='25' fontWeight='bold'>Electrode</text>
      <path d="M275 139L265 133.226L265 144.773L275 139ZM0 139L8.74228e-08 140L266 140L266 139L266 138L-8.74228e-08 138L0 139Z" fill="#002D62" />
      <path d="M825 139L815 133.226L815 144.773L825 139ZM550 139L550 140L816 140L816 139L816 138L550 138L550 139Z" fill="#002D62" />
      <path d="M825 307L815 301.226L815 312.773L825 307ZM550 307L550 308L816 308L816 307L816 306L550 306L550 307Z" fill="#002D62" />

      <text fill='#1C1C1F' x='58' y='109' fontSize='14'>{`Feed Pressure = ${dilution_output.feed_pressure.toFixed(1)} ${System_units.Pressure}`}</text>
      <text fill='#1C1C1F' x='58' y='125' fontSize='14'>{`Feed Flow = ${dilution_output.feed_flow.toFixed(2)} ${System_units['Volume Flow']}`}</text>

      <text fill='#1C1C1F' x='591' y='109' fontSize='14'>{`Product Pressure = ${dilution_output.prod_pressure.toFixed(1)} ${System_units.Pressure}`}</text>
      <text fill='#1C1C1F' x='591' y='125' fontSize='14'>{`Product Flow = ${dilution_output.prod_flow.toFixed(2)} ${System_units['Volume Flow']}`}</text>

      <text fill='#1C1C1F' x='562' y='277' fontSize='14'>{`Max. Electrode Bleed Pressure = ${dilution_output.max_electrode_bleed_press.toFixed(1)} ${System_units.Pressure}`}</text>
      <text fill='#1C1C1F' x='590' y='292' fontSize='14'>{`Electrode Bleed Flow = ${dilution_output.electrode_bleed_flow.toFixed(2)} ${System_units['Volume Flow']}`}</text>

      <text fill='#1C1C1F' x='283' y='40' fontSize='14'>{`Current/Stack =  ${dilution_output.current_stack.toFixed(1)} A`}</text>
      <text fill='#1C1C1F' x='283' y='55' fontSize='14'>{`Stack Voltage =  ${dilution_output.voltage.toFixed(1)} V`}</text>
      <text fill='#1C1C1F' x='283' y='70' fontSize='14'>{`Energy Consumption = ${dilution_output.energy_cons.toFixed(2)} kWh/m3`}</text>
      <text fill='#1C1C1F' x='283' y='85' fontSize='14'>{`Maximum Recovery = ${dilution_output.max_all_recovery.toFixed(1)} %`}</text>

      {!cocurrent ? (<>
        <text fill='#1C1C1F' x='25' y='195' fontSize='14'>{`Max. Conc. outlet pressure = ${dilution_output.max_conc_outlet_press.toFixed(1)} ${System_units.Pressure}`}</text>
        <text fill='#1C1C1F' x='50' y='210' fontSize='14'>{`Conc. Bleed flow = ${dilution_output.conc_bleed_flow.toFixed(2)} ${System_units['Volume Flow']}`}</text>
        <path d="M0 223L10 228.774V217.226L0 223ZM275 223V222L9 222V223V224L275 224V223Z" fill="#002D62" />
      </>) : (<>
        <path d="M278 223L268 217.226L268 228.773L278 223ZM3 223L3 224L269 224L269 223L269 222L3 222L3 223Z" fill="#002D62" />
        <text fill='#1C1C1F' x='25' y='210' fontSize='14'>{`Max. Conc. inlet pressure = ${dilution_output.max_conc_inlet_press.toFixed(1)} ${System_units.Pressure}`}</text>
      </>)}
      {cocurrent ? (<>
        <text fill='#1C1C1F' x='579' y='195' fontSize='14'>{`Max. Conc. outlet pressure = ${dilution_output.max_conc_outlet_press.toFixed(1)} ${System_units.Pressure}`}</text>
        <text fill='#1C1C1F' x='604' y='210' fontSize='14'>{`Conc. Bleed flow = ${dilution_output.conc_bleed_flow.toFixed(2)} ${System_units['Volume Flow']}`}</text>
        <path d="M831 223L821 217.226L821 228.773L831 223ZM556 223L556 224L822 224L822 223L822 222L556 222L556 223Z" fill="#002D62" style={{ transform: 'translate(-6px, 5px)' }} />
      </>) : (<>
        <path d="M553 223L563 228.774V217.226L553 223ZM828 223V222L562 222V223V224L828 224V223Z" fill="#002D62" />
        <text fill='#1C1C1F' x='579' y='210' fontSize='14'>{`Max. Conc. inlet pressure = ${dilution_output.max_conc_inlet_press.toFixed(1)} ${System_units.Pressure}`}</text>
      </>)}
      {!cocurrent ?
        <text fill='#1C1C1F' x='577' y='13' fontSize='16' style={{ transform: 'translate(-17px, 0px)' }}>Flow Configuration - Counter-Current</text> :
        <text fill='#1C1C1F' x='577' y='13' fontSize='16'>Flow Configuration - Co-Current</text>
      }
    </svg>
  );
};
export default SchematiDiagramSVG;